import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import Button from '../../../Button';
import Avatar from '../../../Avatar';
import Icon from '../../../Icon';

import styles from './index.styl';

const HorizontalCard = ({
  logo,
  name,
  organization,
  totalPosts,
  totalUsers,
  onClick,
  joinCommunity,
  buttonInfo,
  counter,
}) => (
  <li styleName="card">
    <div styleName="wrapper">
      <div role="presentation" styleName="avatar" onClick={onClick}>
        <Avatar
          children={name}
          src={logo}
          size={100}
          bordered
          position="center"
          sizePercent
          rootStyle={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        />
      </div>
      <div styleName="content" onClick={onClick} role="presentation">
        <div styleName="title">{name}</div>
        <div styleName="subtitle" className="mb2">
          {organization}
        </div>
        <div styleName="subtitle">
          <Icon
            name="icon-members"
            height="15%"
            width="4%"
            className="mr1"
            style={{ minWidth: 12, minHeight: 12 }}
          />
          <span>{totalUsers}</span>
          <Icon
            name="icon-posts"
            height="15%"
            width="4%"
            className="mr1"
            style={{ minWidth: 12, minHeight: 12 }}
          />
          <span>{totalPosts}</span>
        </div>
      </div>
      <If condition={!!buttonInfo}>
        <Button
          color="primary"
          disabled={buttonInfo.disabled}
          className="w-35 flex-grow-1 flex-shrink-0"
          onClick={joinCommunity}
        >
          {buttonInfo.buttonText}
        </Button>
      </If>
      <If condition={!!counter}>
        <div styleName="badge">
          <span styleName="badge-text">{counter}</span>
        </div>
      </If>
    </div>
  </li>
);

HorizontalCard.propTypes = {
  logo: PropTypes.string,
  name: PropTypes.string,
  organization: PropTypes.string,
  totalPosts: PropTypes.number,
  totalUsers: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  joinCommunity: PropTypes.func,
  buttonInfo: PropTypes.object,
  counter: PropTypes.number,
};

HorizontalCard.defaultProps = {
  logo: '',
  joinCommunity: null,
  buttonInfo: null,
  name: null,
  totalUsers: null,
  totalPosts: null,
  organization: null,
  counter: 0,
};

export default CSSModules(HorizontalCard, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Communities/Components/HorizontalCard/index.jsx